import { IEasyfyEvent, IDataMapper, IEasyfyEventExporter } from '@shared/easyfy.events/easyfy.eventdata';

/* Klaviyo Exporter class */
export class KlaviyoEventExporter implements IEasyfyEventExporter {
  mapper: IDataMapper;
  WithMapper(mapper: IDataMapper): void {
    this.mapper = mapper;
  }

  RegisterEvent(event: IEasyfyEvent): Promise<any> {
    return new Promise<void>(async (resolve) => {
      if (this.mapper) {
        var eventData = this.mapper.MapEventData(event);

        if (eventData?.event && eventData?.data) {
          await this.PushToKlaviyo(eventData);
        }

        if (eventData?.identify) {
          await this.IdentifyUser(eventData.identify);
        }
      }
      resolve();
    });
  }

  async PushToKlaviyo(klaviyoEvent: any): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      if (klaviyoEvent) {
        window['klaviyo'] = window?.['klaviyo'] || [];
        window['klaviyo'].push(["track", klaviyoEvent.event, klaviyoEvent.data])

        //console.group('%c Klaviyo ', 'color: #bada55');
        //console.dir(window['klaviyo']);
        //console.groupEnd();
        resolve(true)
      }
      else {
        resolve(false);
      }
    });
  }
  async IdentifyUser(emailToRegister: any): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      if (emailToRegister) {
        window['klaviyo'] = window?.['klaviyo'] || [];
        window['klaviyo'].identify({
          'email': emailToRegister
        });

        resolve(true)
      }
      else {
        resolve(false);
      }
    });
  }
}